module.exports = __webpack_public_path__ + "static/media/500028.c14e06a2.svg";